import { Directive, Inject, Input, OnDestroy, OnInit } from 'angular-ts-decorators';

@Directive({
  selector: '[compareBasketMessage]',
})
export class CompareBasketMessageDirective implements OnInit, OnDestroy {
  public static $inject: ReadonlyArray<string> = ['$element', '$document'];

  @Input() public basketFull?: boolean;
  @Input('@') public animationClass?: string;

  private removeAnimationClassTimeout = 3000; // duration is equal to the animation duration in css

  constructor(
    @Inject('$element') private $element: JQLite,
    @Inject('$document') private $document: ng.IDocumentService,
  ) { }

  public ngOnInit(): void {
    this.$document.on('click', 'compare-checkbox', this.onClick.bind(this));
  }

  public ngOnDestroy(): void {
    this.$document.off('click', this.onClick);
  }

  private onClick(): void {
    if (!this.basketFull) {
      return;
    }

    this.$element.addClass(this.animationClass);
    setTimeout((): void => {
      this.$element.removeClass(this.animationClass);
    }, this.removeAnimationClassTimeout);
  }
}
